"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = exports.Offer = exports.ADSOffer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/* istanbul ignore next */

var Product = _propTypes.default.shape({
  title: _propTypes.default.string,
  abbr: _propTypes.default.string,
  description: _propTypes.default.string,
  category: _propTypes.default.string,
  bank: _propTypes.default.string
});
exports.Product = Product;
var ADSOffer = _propTypes.default.shape({
  term: _propTypes.default.number,
  minMonthlyPayments: _propTypes.default.string,
  maxMonthlyPayments: _propTypes.default.string,
  apr: _propTypes.default.string,
  minimumTotalCost: _propTypes.default.string,
  maximumTotalCost: _propTypes.default.string
});
exports.ADSOffer = ADSOffer;
var Offer = _propTypes.default.shape({
  term: _propTypes.default.number,
  monthlyPayments: _propTypes.default.string,
  minimumApr: _propTypes.default.string,
  maximumApr: _propTypes.default.string,
  totalCost: _propTypes.default.string
});
exports.Offer = Offer;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator-v2/dist/client/components/scss/index.scss');